import "./PartnerPage.scss";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import {
  ContentArea,
  GridPresetWideContent,
  GridRow,
  HeroBasic,
} from "/App.Components";
import { PartnerPageProps } from "/Models/Generated/PartnerPageProps";
import { ContentAreaItemMargin } from "../../Shared/ContentAreaItem/ContentAreaItem";

const PartnerPage = ({ pageHeader, contentArea }: PartnerPageProps) => (
  <div className="partner-page-norad">
    {pageHeader && <HeroBasic {...pageHeader} />}
    <div className="partner-page-norad__main-body">
      <GridRow>
        <GridPresetWideContent>
          <ContentArea
            {...contentArea}
            contentAreaType={ContentAreaType.FullWidth}
            margin={ContentAreaItemMargin.Huge}
          />
        </GridPresetWideContent>
      </GridRow>
    </div>
  </div>
);

export default PartnerPage;
